export var DropdownLabels;
(function (DropdownLabels) {
    DropdownLabels["EMPTY_PLACEHOLDER"] = "Select...";
    DropdownLabels["NO_OPTIONS"] = "No Options";
    DropdownLabels["LOCKED"] = "Locked";
    DropdownLabels["SEARCH"] = "Search";
    DropdownLabels["CLEAR"] = "Clear selected value";
    DropdownLabels["SHOW_DROPDOWN"] = "Show dropdown list";
})(DropdownLabels || (DropdownLabels = {}));
//# sourceMappingURL=DropdownLabels.js.map